import React, { useState, useRef } from 'react';
import styled, { keyframes } from 'styled-components';

const musicPulse = keyframes`
  0%, 100% { transform: scale(1); }
  50% { transform: scale(1.15); }
`;

const MusicButton = styled.button`
  position: fixed;
  top: 20px;
  right: 20px;
  padding: 15px;
  font-size: 2em;
  background: linear-gradient(135deg, #667eea, #764ba2);
  color: white;
  border: 3px solid white;
  border-radius: 50%;
  cursor: pointer;
  z-index: 1000;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.3);
  transition: all 0.3s;
  width: 60px;
  height: 60px;
  display: flex;
  align-items: center;
  justify-content: center;
  animation: ${musicPulse} 2s ease-in-out infinite;

  &:hover {
    transform: scale(1.2);
    box-shadow: 0 6px 20px rgba(0, 0, 0, 0.4);
  }

  @media (max-width: 768px) {
    top: 10px;
    right: 10px;
    width: 50px;
    height: 50px;
    font-size: 1.5em;
  }
`;

function MusicToggle() {
  const [isPlaying, setIsPlaying] = useState(false);
  const audioRef = useRef(null);

  const toggleMusic = () => {
    if (isPlaying) {
      audioRef.current.pause();
    } else {
      audioRef.current.play();
    }
    setIsPlaying(!isPlaying);
  };

  return (
    <>
      <audio ref={audioRef} loop>
        <source src="https://www.bensound.com/bensound-music/bensound-ukulele.mp3" type="audio/mpeg" />
      </audio>
      <MusicButton 
        className={isPlaying ? 'playing' : ''}
        onClick={toggleMusic}
      >
        {isPlaying ? '🎶' : '🎵'}
      </MusicButton>
    </>
  );
}

export default MusicToggle;
